import { Container, Row, Col, Button } from '@themesberg/react-bootstrap';
import React, { useState, useEffect } from 'react';
import { get, post } from '../../../services/back.service';
import { uploadWithSignedUrl } from '../../../utils/uploadSignedUrl';
import useAutosave from '../../../hooks/useAutosave';

const FormVehiclePicturePlus = ({ id }) => {
  const [bodyImages, setbodyImages] = useState([]);
  const [msgButton, setMsgButton] = useState('Guardar Informacion')

  const autosave = useAutosave(async () => {
    const images = bodyImages.map(({ base64, ...rest }) => rest);
    await post('/peritaje/modifyinspection/pictures/' + id, {
      type: 'AI',
      images
    });
  });

  const deleteImage = async (name) => {
    autosave.cancel();
    setbodyImages((prev) => prev.filter((e) => (e.original_name || e.name) !== name));
    const input = document.getElementById(name);
    if (input) input.value = null;
    await get(`/peritaje/deleteimage/${id}`, {}, { 'type': 'AI', 'name': name });
  };

  const showConvertImage = async ({ target }) => {
    const { files } = target;
    const tmpFile = bodyImages;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const existingIndex = tmpFile.findIndex((image) => image.name === file.name);
      if (existingIndex < 0 && tmpFile.length >= 12) continue;
      try {
        const metadata = await uploadWithSignedUrl(file, id, 'AI', 'images');
        const preview = URL.createObjectURL(file);
        const image = { ...metadata, name: metadata.original_name, base64: preview };
        if (existingIndex >= 0) {
          tmpFile[existingIndex] = image;
        } else {
          tmpFile.push(image);
        }
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    }
    setbodyImages([...tmpFile])
    autosave.schedule();
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    let respo;
    const images = bodyImages.map(({ base64, ...rest }) => rest);
    const body = {
      type: 'AI',
      images
    };
    respo = await post('/peritaje/modifyinspection/pictures/' + id, body);
    if (respo.success) {
      setMsgButton('Actualizar')
    };
  };

  useEffect(() => {
    const initForm = async () => {
      const respo = await get('/peritaje/downloadimages/AI/' + id, {});
      if (respo.success) {
        let finalData = respo.data;
        // if (finalData.length < 12) finalData.push({})
        setbodyImages(finalData);
      }
    };
    initForm();
  }, [id]);

  return (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">Fotos Adicionales Vehiculo</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <div className="image-upload-wrap">
          <input className="file-upload-input" multiple type='file' onChange={(e) => { showConvertImage(e); }} accept="image/*" />
          <div className="drag-text">
            <h3>Drag and drop a file or select add Image</h3>
          </div>
        </div>
        <div className="side_view">
          {
            bodyImages.map((image, i) => {
              return <div key={i}><img
                id={image.name}
                alt="sin imagen"
                src={image.base64}
              />
                <Button type="button" variant="outline-primary" onClick={(e) => deleteImage(image.name)}>borrar</Button>
              </div>
            })
          }
        </div>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default FormVehiclePicturePlus;